const lang = {
    en:{
        search: "Search",
        gptSearchPlaceHolder: "what would you like to watch today",
        gptAPIPlaceHolder: "Enter Your Openai API key"
    },
    hindi:{
        search: "खोज",
        gptSearchPlaceHolder: "आज आप क्या देखना चाहेंगे?",
        gptAPIPlaceHolder: "अपनी Openai API कुंजी दर्ज करें"
    },
    tamil:{
        search: "தேடல்",
        gptSearchPlaceHolder: "இன்று நீங்கள் என்ன பார்க்க விரும்புகிறீர்கள்",
        gptAPIPlaceHolder: "உங்கள் Openai API விசையை உள்ளிடவும்"
    }
}
export default lang